import { useState, useEffect } from 'react';
import { API, DAY_LABELS } from './constants';

export const SendWindowSettings = () => {
  const [windows, setWindows] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetch(`${API}/email/settings/send-windows`, { credentials: 'include' })
      .then(r => r.json()).then(d => setWindows(d.windows || {})).catch(() => {});
  }, []);

  const handleSave = async () => {
    setSaving(true);
    await fetch(`${API}/email/settings/send-windows`, {
      method: 'PUT', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ windows }),
    });
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const updateDay = (day, field, value) => {
    setWindows(prev => ({ ...prev, [day]: { ...prev[day], [field]: value } }));
  };

  if (!windows) return null;

  return (
    <div className="space-y-6" data-testid="send-window-settings">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-heading text-base font-semibold">Verzendvensters</h3>
          <p className="text-xs text-zinc-500 mt-0.5">Stel per dag in wanneer emails verzonden mogen worden (lokale tijd ontvanger)</p>
        </div>
        <div className="flex items-center gap-2">
          {saved && <span className="text-xs text-emerald-600 font-medium">Opgeslagen!</span>}
          <button onClick={handleSave} disabled={saving} data-testid="save-send-windows-btn"
            className="px-4 py-2 text-sm font-medium bg-[#0055FF] text-white hover:bg-blue-700 disabled:opacity-50 transition-colors">
            {saving ? 'Opslaan...' : 'Opslaan'}
          </button>
        </div>
      </div>

      <div className="border border-zinc-200 bg-white overflow-hidden" data-testid="send-windows-table">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 text-zinc-500 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left p-3 font-medium w-40">Dag</th>
              <th className="text-center p-3 font-medium w-24">Actief</th>
              <th className="text-left p-3 font-medium">Begintijd</th>
              <th className="text-left p-3 font-medium">Eindtijd</th>
              <th className="text-left p-3 font-medium">Venster</th>
            </tr>
          </thead>
          <tbody>
            {[0, 1, 2, 3, 4, 5, 6].map(day => {
              const cfg = windows[day] || {};
              const isWeekend = day >= 5;
              return (
                <tr key={day} className={`border-t border-zinc-100 ${!cfg.enabled ? 'opacity-50 bg-zinc-50' : isWeekend ? 'bg-amber-50/30' : ''}`} data-testid={`send-window-day-${day}`}>
                  <td className="p-3 font-medium">{DAY_LABELS[day]}</td>
                  <td className="p-3 text-center">
                    <input type="checkbox" checked={cfg.enabled !== false}
                      onChange={e => updateDay(day, 'enabled', e.target.checked)}
                      className="w-4 h-4 accent-[#0055FF]" data-testid={`toggle-day-${day}`} />
                  </td>
                  <td className="p-3">
                    <input type="time" value={cfg.start || '06:30'} disabled={!cfg.enabled}
                      onChange={e => updateDay(day, 'start', e.target.value)}
                      className="border border-zinc-200 px-2 py-1 text-sm rounded-sm disabled:bg-zinc-100 disabled:text-zinc-400" data-testid={`start-time-${day}`} />
                  </td>
                  <td className="p-3">
                    <input type="time" value={cfg.end || '19:00'} disabled={!cfg.enabled}
                      onChange={e => updateDay(day, 'end', e.target.value)}
                      className="border border-zinc-200 px-2 py-1 text-sm rounded-sm disabled:bg-zinc-100 disabled:text-zinc-400" data-testid={`end-time-${day}`} />
                  </td>
                  <td className="p-3 text-xs text-zinc-500">
                    {cfg.enabled !== false ? (
                      <span>{cfg.start || '06:30'} - {cfg.end || '19:00'} <span className="text-zinc-400">({(() => {
                        const [sh, sm] = (cfg.start || '06:30').split(':').map(Number);
                        const [eh, em] = (cfg.end || '19:00').split(':').map(Number);
                        const mins = (eh * 60 + em) - (sh * 60 + sm);
                        const h = Math.floor(mins / 60);
                        const m = mins % 60;
                        return `${h}u${m > 0 ? ` ${m}m` : ''}`;
                      })()})</span></span>
                    ) : <span className="italic text-red-400">Geen verzending</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="text-xs text-zinc-400 space-y-1">
        <p>Alle tijden zijn lokale tijd van de ontvanger (gebaseerd op landcode).</p>
        <p>Emails buiten het venster worden automatisch uitgesteld naar het eerstvolgende openstaande venster.</p>
      </div>
    </div>
  );
};
